import { useTranslation } from 'react-i18next'

import { downloadCSV } from 'common'

import { get1095Report, getPcoriReportDownload } from 'core'
import { PlanPeriodDto } from 'core/application/adminDashboard/benefitDetails/benefitPlanPeriods'
import getReportDownload from 'core/application/adminDashboard/reports/getReport'

import { Button, Card, Icon } from 'common/components'
import { formatYear } from 'common/dateFormatters'
import { useBreakPoints, useQueryRequest } from 'common/hooks'

interface ReportCardButtonProps {
  title: string
  period: PlanPeriodDto
}

const ReportCardButton = ({ title, period }: ReportCardButtonProps) => {
  const { t: translate } = useTranslation()
  const { isMd } = useBreakPoints()
  const [, downloadReportloading, sendGetDownloadReport] = useQueryRequest<any>(null)

  const reportInfo = () => {
    switch (title) {
      case 'W-2 amounts':
        return {
          fileName: 'W2_amounts_report_',
          message: 'W-2 amounts',
          download: getReportDownload(period.id),
        }
      case 'PCORI Reports':
        return {
          fileName: 'POCRI_report_',
          message: 'PCORI Annual Report',
          download: getPcoriReportDownload(period.id),
        }
      case '1095-C Reports':
        return {
          fileName: '1095-C_report_',
          message: '1095-C Reports',
          download: get1095Report(period.id),
        }
      default:
        return {
          fileName: 'W2_amounts_report_',
          message: 'W-2 amounts',
          download: get1095Report(period.id),
        }
    }
  }

  return (
    <Card className="ReportCard-card mb-16" key={period.id}>
      <div className={isMd ? 'flex flex__space_between flex__align_center' : ''}>
        <div className={isMd ? 'flex' : 'flex mb-8'}>
          <div className="font-20 mr-16">
            <Icon type="fal fa-file-invoice" fontAwesome />
          </div>

          <div className="flex flex__align_center text-light-bold color-gray-9">
            {reportInfo().message} {formatYear(period.startDate)}
          </div>
        </div>
        <Button
          type="primary"
          icon="fa fa-download"
          loading={downloadReportloading}
          onClick={async () => {
            const result = await sendGetDownloadReport(() => reportInfo().download)
            downloadCSV(result, `${reportInfo().fileName}${formatYear(period.startDate)}`)
          }}
        >
          {translate('admin-dashboard.reports.download')}
        </Button>
      </div>
    </Card>
  )
}

export default ReportCardButton
